import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogInIcon } from 'lucide-react';
import { LoadingScreen } from '../components/LoadingScreen';
import { useAuth } from '../contexts/AuthContext';
export function Login() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate loading time for dashboard data
    setTimeout(() => {
      login();
      navigate('/overview');
    }, 2000);
  };
  if (isLoading) {
    return <LoadingScreen data-id="element-7261" />;
  }
  return <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-gray-100 flex items-center justify-center px-4" data-id="element-7262">
      <div className="max-w-md w-full" data-id="element-7263">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8" data-id="element-7264">
          <div className="flex justify-center mb-6" data-id="element-7265">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aZxoSgpvWGaSLuSteDWmq1/Maybank_logo.svg" alt="Maybank" className="h-12 w-auto" data-id="element-7266" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-7267">
            Welcome Back
          </h2>
          <p className="text-gray-600 text-center mb-8" data-id="element-7268">
            Sign in to your account to continue
          </p>
          <form onSubmit={handleLogin} className="space-y-6" data-id="element-7269">
            <div data-id="element-7270">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7271">
                Email Address
              </label>
              <input type="email" placeholder="simon.verraest@maybank.com" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFB81C] focus:border-[#FFB81C] outline-none transition-colors" data-id="element-7272" />
            </div>
            <div data-id="element-7273">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7274">
                Password
              </label>
              <input type="password" placeholder="••••••••" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FFB81C] focus:border-[#FFB81C] outline-none transition-colors" data-id="element-7275" />
            </div>
            <div className="flex items-center justify-between" data-id="element-7276">
              <label className="flex items-center" data-id="element-7277">
                <input type="checkbox" className="h-4 w-4 text-[#FFB81C] focus:ring-[#FFB81C] border-gray-300 rounded" data-id="element-7278" />
                <span className="ml-2 text-sm text-gray-600" data-id="element-7279">Remember me</span>
              </label>
              <button type="button" className="text-sm text-[#FFB81C] hover:text-[#FFA000] font-medium" data-id="element-7280">
                Forgot password?
              </button>
            </div>
            <button type="submit" className="w-full bg-[#FFB81C] hover:bg-[#FFA000] text-black font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center" data-id="element-7281">
              <LogInIcon size={18} className="mr-2" data-id="element-7282" />
              Sign In
            </button>
          </form>
          <div className="mt-6 text-center" data-id="element-7283">
            <p className="text-sm text-gray-600" data-id="element-7284">
              Don't have an account?{' '}
              <button className="text-[#FFB81C] hover:text-[#FFA000] font-medium" data-id="element-7285">
                Contact Sales
              </button>
            </p>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-7286">
          <p className="text-sm text-gray-500" data-id="element-7287">
            © 2025 Maybank. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}